import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  InputAdornment,
  MenuItem,
  Select,
  SelectChangeEvent,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { Router, useNavigate } from "react-router-dom";
import IosSwitchMain from "../../../components/iosSwitchMain";
import {
  LocalizationProvider,
  DatePicker,
  DateTimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

interface OthersFormProps {
  alignment: string;
}


function ExperienceForm({ alignment }: OthersFormProps) {
  const navigate = useNavigate();
  const [isCancellationEnabled, setIsCancellationEnabled] = useState(false);
  const [valueTabs, setValueTabs] = React.useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const [valueTabs1, setValueTabs1] = React.useState(0);
  const handleChangeTabs2 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
  };

  const [value, setValue] = React.useState({
    page: "0",
    type: "0",
  });

  const handleChange1 = (event: SelectChangeEvent) => {
    const { name, value } = event.target;
    setValue((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <>
      <div className="section_title mn_hdng">
        <h2>Contact Dealer</h2>
      </div>

      <div className="gap_m avnc_bkng">
        <div className="control_group w_50">
          <label> Date</label>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              className="form_control"
              slots={{
                openPickerIcon: () => (
                  <img src="/static/images/calendar_icon.svg" alt="icon" />
                ),
                textField: (params) => (
                  <TextField
                    {...params}
                    fullWidth
                    placeholder="Date"
                    hiddenLabel
                  />
                ),
              }}
              desktopModeMediaQuery="(min-width:0px)"
            />
          </LocalizationProvider>
        </div>
        <div className="w_50 control_group">
          <label> Time</label>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              className="form_control"
              slots={{
                openPickerIcon: () => (
                  <img src="/static/images/calendar_icon.svg" alt="icon" />
                ),
                textField: (params) => (
                  <TextField
                    {...params}
                    fullWidth
                    placeholder=" Time"
                    hiddenLabel
                  />
                ),
              }}
              desktopModeMediaQuery="(min-width:0px)"
            />
          </LocalizationProvider>
        </div>
        <div className="control_group w_50">
          <label>Whats App Number</label>
          <TextField placeholder="Number" hiddenLabel fullWidth />
        </div>

        <Box className="custom_tabs2 mt_40 mb_30" sx={{ width: "100%" }}>
          <Tabs
            aria-label="basic tabs example"
            className="custom_tabs_links"
            value={valueTabs}
            onChange={(e, newValue) => setValueTabs(newValue)}
          >
            <Tab {...a11yProps(0)} label="+ Add Custom" />
            <Tab {...a11yProps(1)} label="+ Add Previous Questions" />
          </Tabs>
        </Box>

        <CustomTabPanel value={valueTabs} index={0}>
          <div className="control_group w_100 cstm_mn">
            <div className="gap_m">
              <div className="control_group w_50">
                <label>Select Type</label>

                <Select
                  className="dropse"
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  inputProps={{
                    "aria-label": "Without label",
                  }}
                  displayEmpty
                  name="type"
                  value={value.type}
                  onChange={handleChange1}
                >
                  <MenuItem value="0" disabled>
                    Select Type
                  </MenuItem>

                  <MenuItem value="10"> Checkbox</MenuItem>
                  <MenuItem value="20">Input</MenuItem>
                </Select>
              </div>

              <div className="control_group w_50">
                <label>Enter Question</label>
                <TextField placeholder="Question" hiddenLabel fullWidth />
              </div>
            </div>
          </div>

          <div className="control_group w_100">
            <label>Add Options</label>
            <TextField placeholder="Option Text" hiddenLabel fullWidth />
          </div>
          <div className="control_group w_100 chkbx_mn">
            <FormControlLabel
              control={<Checkbox />}
              name="remember"
              label="Save this question for other offers"
            />
            <Button className="btn btn_primary">+ Add Option</Button>
          </div>

          <div className="control_group w_100 prfrnc">
            <label>
              Seating preferences{" "}
              <img src="/static/images/edit_icon.svg" alt="icon" />{" "}
            </label>
            <FormGroup>
              <FormControlLabel
                control={<Checkbox defaultChecked />}
                label="Indoor Seating"
              />
              <FormControlLabel
                control={<Checkbox />}
                label="Outdoor Seating"
              />
              <FormControlLabel control={<Checkbox />} label="Indoor Seating" />
              <FormControlLabel
                control={<Checkbox />}
                label="Outdoor Seating"
              />
              <FormControlLabel
                control={<Checkbox />}
                label="Outdoor Seating"
              />
              <FormControlLabel
                control={<Checkbox />}
                label="Outdoor Seating"
              />
            </FormGroup>
          </div>
        </CustomTabPanel>
        <div className="control_group w_100">
          <CustomTabPanel value={valueTabs} index={1}>
            <div className="cards crds_mn">
              <Box className="custom_tabs2  mb_30" sx={{ width: "100%" }}>
                <Tabs
                  aria-label="basic tabs example"
                  className="custom_tabs_links"
                  value={valueTabs}
                  onChange={(e, newValue) => setValueTabs(newValue)}
                >
                  <Tab {...a11yProps(0)} label="Checkbox" />
                  <Tab {...a11yProps(1)} label="Text" />
                  <Tab {...a11yProps(2)} label="Radio" />
                  <Tab {...a11yProps(3)} label="Dropdown" />
                </Tabs>
              </Box>

              <CustomTabPanel value={valueTabs1} index={0}>
                <FormGroup className="prvs_qstn_mn">
                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label={
                      <>
                        <h2>Question 1</h2>
                        <p>Seating preferences</p>
                        <FormGroup className="prfrnc">
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                        </FormGroup>
                      </>
                    }
                  />

                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label={
                      <>
                        <h2>Question 2</h2>
                        <p>Seating preferences</p>
                        <FormGroup className="prfrnc">
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                        </FormGroup>
                      </>
                    }
                  />
                </FormGroup>
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs1} index={1}>
                <FormGroup className="prvs_qstn_mn">
                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label={
                      <>
                        <h2>Question 1</h2>
                        <p>Seating preferences</p>
                        <FormGroup className="prfrnc">
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                        </FormGroup>
                      </>
                    }
                  />

                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label={
                      <>
                        <h2>Question 2</h2>
                        <p>Seating preferences</p>
                        <FormGroup className="prfrnc">
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                        </FormGroup>
                      </>
                    }
                  />
                </FormGroup>
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs1} index={2}>
                <FormGroup className="prvs_qstn_mn">
                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label={
                      <>
                        <h2>Question 1</h2>
                        <p>Seating preferences</p>
                        <FormGroup className="prfrnc">
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                        </FormGroup>
                      </>
                    }
                  />

                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label={
                      <>
                        <h2>Question 2</h2>
                        <p>Seating preferences</p>
                        <FormGroup className="prfrnc">
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                        </FormGroup>
                      </>
                    }
                  />
                </FormGroup>
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs1} index={3}>
                <FormGroup className="prvs_qstn_mn">
                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label={
                      <>
                        <h2>Question 1</h2>
                        <p>Seating preferences</p>
                        <FormGroup className="prfrnc">
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                        </FormGroup>
                      </>
                    }
                  />

                  <FormControlLabel
                    control={<Checkbox defaultChecked />}
                    label={
                      <>
                        <h2>Question 2</h2>
                        <p>Seating preferences</p>
                        <FormGroup className="prfrnc">
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outdoor Seating"
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Indoor Seating"
                          />
                        </FormGroup>
                      </>
                    }
                  />
                </FormGroup>
              </CustomTabPanel>
              <div className="btn_flex flx_end" >
                <Button className="btn btn_primary">Save</Button>
              </div>
            </div>
          </CustomTabPanel>
        </div>

        <div className="btn_flex flx_end">
          {alignment === "archived" && (
            <Button
              className="btn btn_primary"
              onClick={() =>
                navigate("/manage-offer")
              }
            >
              Save & Exit
            </Button>
          )}
          <Button
            className="btn btn_primary"
            onClick={() => navigate("/manage-offer/preview-offer?mode=EXPERIENCE")}
          >
            Preview
          </Button>
        </div>
      </div>
    </>
  );
}

export default ExperienceForm;
